export default __webpack_public_path__ + "static/media/tabee_firm.ecb920b8.svg";